import script from "./home.vue?vue&type=script&setup=true&lang=js"
export * from "./home.vue?vue&type=script&setup=true&lang=js"

import "./home.vue?vue&type=style&index=0&id=0d9a260e&scoped=true&lang=css"

import exportComponent from "/Users/jmallach/Dev/jicub/vuejs-bosb-microsite/my-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d9a260e"]])

export default __exports__